// TODO how to setup signin to client. May differ. But likely Oauth.
// Must be handled directly by the client, not the cache.

import {
  IndividualRefreshEvent,
  IndividualDeleteEvent,
  CollectionSizeUpdateEvent,
  CacheUpdateEvent,
  CacheDeleteEvent,
} from '@/rec-cache/rec-cache-events'

import { Namespaces } from '@/rec-cache/rec-cache-namespaces'

import { IndexSelector } from '@/rec-cache/rec-cache-index-selector'

import { GeoCoordSelector } from './rec-cache-geo-coord-selector'

import { TypeSelector } from './rec-cache-type-selector'

import { Individuals } from './rec-cache-named-individuals'

import { ObjectProperty, DataProperty, Iri } from './rec-cache-types'

import { Edge } from './rec-cache-edge'
import { RecComponent } from './rec-cache-component'

// import { RecIndividual } from '@/rec-cache/rec-cache-individual'

// TODO rename class...
import { Owl } from '@/rec-cache/owl'

/// TODO the aggregators / component implementation only works with outgoing relationships.
class RecCache {
  constructor({
    namespaces = {},
    upAggregators = [],
    downAggregators = [],
    client = null,
    geoCoordinateFn = null,
  } = {}) {
    console.log(
      'rec-cache.rec-cache.constructor',
      namespaces,
      client,
      geoCoordinateFn
    )
    this.namespaces = new Namespaces(namespaces)
    this.downAggregators = downAggregators
    this.upAggregators = upAggregators
    this.client = client

    this.geoCoordinatesFn = geoCoordinateFn

    // Factory for REC individuals
    this.owl = new Owl(this.namespaces)

    // Main databases for the cache.
    this.individuals = []
    this.edges = []
    this.ids = new Set()
    // The type map maps type value to count of individuals of given type.
    // The type set is an array of type values (to fascilitate reactivity).
    this.typeSet = []
    this.typeMap = new Map()

    // Holds a map of component individual id value -> embracing individual IRI.
    // Ie the component is pointing to parent / embracing individual.
    this.aggregates = new Map()

    // Holds a map of individual id value -> geo coordinate
    this.geoCoordinates = new Map()

    // Selectors
    this.indexSelector = new IndexSelector({ ids: this.ids })
    this.geoCoordSelector = new GeoCoordSelector(geoCoordinateFn)
    this.typeSelector = new TypeSelector({ ids: this.ids })

    // Queue for reads initiated while cache is is initial read all state.
    // Maps id value to object with a resolve and reject function.
    this.promisesQueue = new Map()

    // Mount event handlers.
    addEventListener(IndividualRefreshEvent, this.refresh.bind(this))
    addEventListener(IndividualDeleteEvent, this.delete.bind(this))
    addEventListener(CollectionSizeUpdateEvent, this.sizeUpdate.bind(this))

    // Synchronous initialization of the initial read sequence.
    this.client.init()
    // TODO refactored to be started by App.
    // this.client.readAllRequest()

    // Initalize cache properties.
    this._size = 0

    // Sync flag.
    this.isSynced = false
  }

  get size() {
    return this._size
  }

  get inCache() {
    return this.individuals.length
  }

  // Clears the databases of the REC cache and selectors
  clear() {
    this.individuals = []
    this.edges = []
    this.ids.clear()
    this.typeSet = []
    this.typeMap.clear()
    this.aggregates.clear()
    this.geoCoordinates.clear()
    this._size = 0
    this.isSynced = false

    this.indexSelector.clear()
    this.geoCoordSelector.clear()
    this.typeSelector.clear()

    this.promisesQueue.clear()
  }

  // TODO cache the Individuals array with lower case in constructor.
  isIndividual(id) {
    return !!Individuals.find((i) => i.toLowerCase() == id.value.toLowerCase())
  }

  // Returns Boolean.
  // Parameter id is an IRI.
  isComponent(id) {
    // console.log(
    //   'rec-cache.rec-cache.is-component',
    //   id,
    //   this.aggregates.has(id.value)
    // )
    return this.aggregates.has(id.value)
  }

  // Returns array of component individual ids as id values.
  // Parameter id is an IRI or id value.
  hasComponents(id) {
    // console.log(
    //   'rec-cache.rec-cache.has-components',
    //   id,
    //   [...this.aggregates.entries()]
    //     .filter((e) => e[1].value == (id.value || id))
    //     .map((e) => e[0])
    // )
    return [...this.aggregates.entries()]
      .filter((e) => e[1].value == (id.value || id))
      .map((e) => e[0])
  }

  // Returns parent individual id as IRI.
  // Parameter id is an IRI or id value.
  getComponentParent(id) {
    // console.log(
    //   'rec-cache.rec-cache.get-component-parent',
    //   id,
    //   this.aggregates.get(id.value || id)
    // )

    return this.aggregates.get(id.value || id)
  }

  // Returns array of GeoCoordinate. Or undefined if not found.
  // Parameter id is an Iri.
  readGeoCoords(id, aggregate = false) {
    if (!this.ids.has(id.value)) return undefined
    const targetId = aggregate
      ? this.isComponent(id)
        ? this.getComponentParent(id)
        : id
      : id
    // Identify geo coordinates on the individual itself and potentially its components.
    const components = aggregate ? [...this.hasComponents(targetId)] : []
    return components
      .concat([targetId.value])
      .map((id) => this.geoCoordinates.get(id))
      .filter((c) => !!c)
  }

  // Returns array of individual id values.
  hasGeoCoords(aggregate = false) {
    return [...this.geoCoordinates.keys()].map((i) =>
      aggregate ? (this.isComponent(i) ? this.getComponentParent(i) : i) : i
    )
  }

  // Returns RecIndividual. Or undefined if not found.
  // For component individuals their parent individual is returned.
  // Parameter id is an IRI or an id value.
  //
  // TODO consider an async version for future proofness.
  read(id, aggregate = false) {
    // TODO crude implementation, refactor logic, see over the other rec cache methods as well.
    id = id instanceof Iri ? id : new Iri(id)

    if (!this.ids.has(id.value)) return undefined

    const targetId = aggregate
      ? this.isComponent(id)
        ? this.getComponentParent(id)
        : id
      : id

    const individual = this.individuals.find(
      (i) => i.id.value == targetId.value
    )

    // console.log(
    //   'rec-cache.rec-cache.read.target',
    //   JSON.parse(JSON.stringify(individual))
    // )

    // Inclusion of aggregated individuals as components.
    const components = this.hasComponents(targetId).map((cId) =>
      this.individuals.find((i) => i.id.value == cId)
    )
    // console.log('rec-cache.rec-cache.read.components', components)

    // TODO components emptied to avoid every read adds the same component.
    // Implies that aggregation wont work on individuals with components.
    //
    individual.components = []
    components.forEach((c) => {
      // Fix for not yet read component individuals. May be changed to a read to cache.
      // TODO or find a way to represent an empty component individual.
      if (c) {
        const component = new RecComponent()
        component.id = c.id
        component.types = c.types
        component.properties = c.properties.filter(
          (p) => p instanceof DataProperty
        )
        component.meta = { geoCoords: c.meta.geoCoords }
        individual.components.push(component)
      }
    })

    // if (individual.components.length)
    //   console.log('rec-cache.rec-cache.read.individual', individual.components)

    return individual
  }

  readAsync(id, aggregate = false) {
    if (this.isSynced) return this.read(id, aggregate)

    // Create and que promises, then start read cycle.
    id = id instanceof Iri ? id : new Iri(id)

    if (this.promisesQueue.has(id.value)) return

    const promiseFns = {}
    const promise = new Promise((resolve, reject) => {
      promiseFns.resolve = resolve
      promiseFns.reject = reject
    })

    this.promisesQueue.set(id.value, promiseFns)
    return promise
  }

  // Returns array of Edge.
  // Parameters are string literals.
  queryEdges({ source = null, target = null, label = null } = {}) {
    // console.log(
    //   'rec-cache.rec-cache.query-edges',
    //   source || 'null',
    //   target || 'null',
    //   label || 'null'
    // )
    // console.log(this.edges.length, this.edges[0])
    // console.log(this.edges.filter((e) => !source || e.source.equals(source)))
    const result = this.edges
      .filter((e) => !source || e.source.equals(source))
      .filter((e) => !target || e.target.equals(target))
      .filter((e) => !label || e.label.equals(label))

    // console.log(result)
    return result
  }

  // Event handler for updating databases. Receives a CustomEvent argument.
  // Parameter jsonldIndividual is an object.
  refresh({ detail: jsonldIndividual }) {
    // console.log('rec-cache.rec-cache.rec-cache.refresh', jsonldIndividual)

    // Parse the received object.
    const individual = this.owl.parse(jsonldIndividual)

    // Decide if new or update - check ids.
    const isUpdate = this.ids.has(individual.id.value)
    // TODO may be refactoed since the splice below will return an array of the deleted individual
    // TODO doesnt seem to be needed!?
    // const oldIndividual =
    //   isUpdate &&
    //   this.individuals.find((i) => i.id.value == individual.id.value)

    // Store to individuals. Overwrite existing if update.
    // TODO check if reactivity will detect update. Unclear if it matters to keep updated individual at same position. Would a Map work better?
    if (isUpdate) {
      // The individual is updated in place to support reactive mechanisms.
      const storedIndividual = this.individuals.find(
        (i) => i.id.value == individual.id.value
      )
      // Only properties can change at an update.
      storedIndividual.properties = individual.properties

      // this.individuals.splice(
      //   this.individuals.findIndex((i) => i.id.value == individual.id.value),
      //   1,
      //   individual
      // )

      // TODO add to updated queue (that is a mechanism to acknowledge an update by the app).
    } else {
      if (this.individuals.length == this._size) {
        // The initial read all has completed,
        // and this is a completion of read cycle for an additional individual, eg an event exception.
        this._size++
      }
      this.individuals.push(individual)
      // TODO crude implementation with both set (for reactivity) and map, to keep track, refactor...
      const typeCount = this.typeMap.get(individual.type.value)
      this.typeMap.set(individual.type.value, typeCount ? typeCount + 1 : 1)
      this.typeSet = [...this.typeMap.keys()]

      // TODO rudimentary implementaiton of sync. Must be based on the clients state...
      this.isSynced = this.individuals.length == this._size
    }

    // TODO consider updating edges in place to support reactivity... needed?
    // Update edges - remove exisitng edges if update, then create edges.
    if (isUpdate) {
      this.edges = this.edges.filter(
        (e) => e.source.value != individual.id.value
      )
    }
    // Create edge for each object property value.
    individual.properties
      .filter((p) => p instanceof ObjectProperty)
      .forEach((p) =>
        p.values.forEach((v) =>
          this.edges.push(new Edge(individual.id, v, p.name))
        )
      )

    // Update aggregates. The aggregates map id value of child to IRI of parent.
    // TODO should only be undertaken on the added edges, not all edges, refactor.
    // Identify down aggregates, ie the source of the edge is the parent.
    this.edges
      .filter(
        (e) =>
          e.source.equals(individual.id.value) &&
          !!this.downAggregators.includes(e.label.value)
      )
      .forEach((e) => this.aggregates.set(e.target.value, individual.id))
    // Identify up aggregates, ie the target of the edge is the parent.
    this.edges
      .filter(
        (e) =>
          e.source.equals(individual.id.value) &&
          !!this.upAggregators.includes(e.label.value)
      )
      .forEach((e) => this.aggregates.set(e.source.value, e.target))

    // TODO add update support, determine if a geo coord has been added or changed (two cases)

    // Add geo coordinates.
    // TODO add support for reactivity, ie let application provide reactive variable.
    // TODO add supprot for several geo coords per individual, ie the geoCoordinatesFn must return array.
    if (this.geoCoordinatesFn) {
      const geoCoord = this.geoCoordinatesFn(individual)
      if (isUpdate) {
        this.geoCoordinates.delete(individual.id.value)
        // TODO when support for multiple this should be a filter on the list. Se also above.
        individual.meta.geoCoords.list = []
      }
      if (geoCoord) this.geoCoordinates.set(individual.id.value, geoCoord)
      if (geoCoord) individual.meta.geoCoords.addGeoCoord(geoCoord)
    }

    // Add to ids.
    this.ids.add(individual.id.value)

    // Issue events for selections.
    // TODO consider rename to cache refresh event...
    dispatchEvent(new CustomEvent(CacheUpdateEvent, { detail: individual }))
  }

  delete({ detail: id }) {
    console.log('rec-cache.rec-cache.rec-cache.delete', id)

    const type = this.read(id).type

    // Remove from cache databases and update size.
    this.individuals = this.individuals.filter((i) => i.id.value != id)
    this.edges = this.edges.filter((e) => e.source.value != id)
    this.aggregates.delete(id)
    const parents = []
    this.aggregates.forEach((value, key) => {
      if (value.value == id) {
        parents.push(key)
      }
    })
    parents.forEach((p) => this.aggregates.delete(p))
    this.ids.delete(id)
    this._size--
    // Remove from type set if its the last individual of this type, ie count equals one.
    const typeCount = this.typeMap.get(type.value)
    if (typeCount == 1) {
      this.typeMap.delete(type.value)
      this.typeSet = [...this.typeMap.keys()]
    } else {
      this.typeMap.set(type.value, typeCount - 1)
    }
    this.geoCoordinates.delete(id)

    // Update selectors by issuing cache delete event.
    dispatchEvent(new CustomEvent(CacheDeleteEvent, { detail: id }))
  }

  // Eventhandler for the size update event.
  sizeUpdate({ detail: size }) {
    this._size = size
  }
}

export { RecCache }
